import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLiveDraw = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.998 5.366a4 4 0 0 0-2.254.69 5.6 5.6 0 0 0-1.79-.426 5.5 5.5 0 0 1 4.044-1.764c1.598 0 3.038.68 4.045 1.765-.625.046-1.221.2-1.77.44a4 4 0 0 0-2.275-.705m-8.47 7.496a4.337 4.337 0 0 1 4.038-4.327 7.4 7.4 0 0 1 2.292-1.16A5.836 5.836 0 0 0 5.67 18.271a7.4 7.4 0 0 1-.926-2.401 4.32 4.32 0 0 1-1.214-3.01m8.47-3.065a4.654 4.654 0 1 0 0 9.309 4.654 4.654 0 0 0 0-9.31M5.844 14.45a6.154 6.154 0 1 1 12.308 0 6.154 6.154 0 0 1-12.308 0m7.557.856c0 .974-.73 1.357-1.705 1.357-.453 0-.905-.07-1.288-.208l.348-.835c.21.07.627.139.905.139.418 0 .626-.14.626-.383 0-.314-.278-.523-.974-.523-.174 0-.383 0-.626.036l.278-2.332h2.332v.87h-1.392l-.07.626c1.044.035 1.566.488 1.566 1.253m3.03-6.77a4.337 4.337 0 0 1 2.827 7.307 7.3 7.3 0 0 1-.925 2.416 5.838 5.838 0 0 0-4.207-10.89c.841.253 1.62.652 2.306 1.167"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgLiveDraw;
